import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

import styles from './PlainButton.module.scss';

interface PlainButtonProps {
  /** @string - React Router Link destination */
  to?: string;
  /** @string - <a> tag href attribute */
  href?: string;
  /** @boolean - Button disabled state */
  disabled?: boolean;
  /** @string - The link href target */
  target?: '_blank' | '_self';
  /** @string - Classname passed to wrapper element */
  className?: string;
  /** @string - Tooltip text */
  tooltipText?: string;
  /** @function - Called when button is clicked */
  onClick?: () => void;
  /** @function - Called when mouse enters element */
  onMouseEnter?: () => void;
  /** @any - Any HTML element or react component */
  Component?: any;
}

export const PlainButton: React.FC<PlainButtonProps> = ({
  to,
  href,
  children,
  disabled,
  className,
  tooltipText,
  onClick,
  Component,
  ...props
}) => {
  if (!Component) {
    if (to) {
      Component = Link;
    } else if (href) {
      Component = 'a';
    } else {
      Component = 'button';
    }
  }

  const buttonClasses = classnames(className, {
      [styles.button]: true,
      [styles.disabled]: disabled,
    }
  );

  return (
    <Component
      to={to}
      href={href}
      data-tooltip={tooltipText}
      onClick={onClick}
      {...props}
      className={buttonClasses}
    >
      {children}
    </Component>
  );
};

export default PlainButton;
